import { Alert } from '@spark-web/alert';
import { Box } from '@spark-web/box';
import { Text } from '@spark-web/text';
import { Step } from '@spark-web/vertical-stepper';
import { APPLICATION_UNDER_REVIEW } from '../../utils';

function ApplicationUnderReviewStep() {
  return (
    <Step>
      <Step.Heading title={APPLICATION_UNDER_REVIEW.TITLE} renderStepNumber={() => ''} />
      <Step.Content>
        <Box paddingBottom="large">
          <Text>{APPLICATION_UNDER_REVIEW.CONTENT}</Text>
        </Box>
        <Alert tone="info" heading={APPLICATION_UNDER_REVIEW.ALERT_TITLE}>
          {APPLICATION_UNDER_REVIEW.ALERT_CONTENT}
        </Alert>
      </Step.Content>
    </Step>
  );
}

export default ApplicationUnderReviewStep;
